module.exports = __webpack_public_path__ + "media/images/cleaning/card-desktop@2x-63f3c80c84b5bf87c3b7bb61e5113212.jpg";